import React from "react";
import LuckyDrawPage from "./pages/LuckyDrawPage";

function App() {
  return <LuckyDrawPage />;
}

export default App;